/**
 *
 * @module deleteUserProfileResult
 *
 */

import Check from 'check-types';

import AccountGrant from './accountGrant';
import InvalidArgumentException from '../exception/invalidArgumentException';

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class DeleteUserProfileResult
 * @since 3.5.0
 *
 */
export default class DeleteUserProfileResult {

    /**
     *
     * @param {AccountGrant} [accountGrant=undefined]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(accountGrant) {

        const errorMessage = {
            ctor: 'DeleteUserProfile(accountGrant)',
            get accountGrant() {
                return `${this.ctor} accountGrant should be an instance of SDK.Services.Account.AccountGrant`;
            }
        };

        if (Check.assigned(accountGrant)) {
            instanceStrict(accountGrant, AccountGrant, errorMessage.accountGrant, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.accountGrant = accountGrant;

    }

}



// WEBPACK FOOTER //
// ./src/services/account/deleteUserProfileResult.js